import { usePunditUserContext } from "@circle-react/contexts/punditUserContext";
import { useSpacesContext } from "@circle-react/contexts/spacesContext";
import { useSpaceSlugFromUrl } from "@circle-react/hooks/useSpaceSlugFromUrl";
import { useLocation } from "@tanstack/react-router";

import { t } from "@/i18n-js/instance";

import type { BreadcrumbCrumb } from "./useSettingsBreadcrumb";

const TOP_NAV_LABELS: Record<string, () => string> = {
  "/feed": () => t("feed"),
  "/members": () => t("members_directory.menu.title"),
  "/events": () => t("events.title"),
  "/courses": () => t("courses.directory.title"),
  "/leaderboard": () => t("leaderboard.title"),
};

export const useMemberBreadcrumb = (): BreadcrumbCrumb[] => {
  const { currentCommunity } = usePunditUserContext();
  const pathname = useLocation({ select: location => location.pathname });
  const spaceSlug = useSpaceSlugFromUrl();
  const { helpers } = useSpacesContext();

  const pageLabel = spaceSlug
    ? helpers.findBy({ slug: spaceSlug })?.name
    : TOP_NAV_LABELS[pathname]?.();

  const label = pageLabel ?? currentCommunity?.name;
  return label ? [{ label }] : [];
};
